export default "__VITE_ASSET__7c7a3e94__"